import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Scale } from '@blade/common/utils/auto-scale';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import CombinedPicture from '@blade-sxp/portrait-management/components/combined-picture.vue';
import { errList } from '@blade-sxp/its-management/api/detail';
let default_1 = class default_1 extends Vue {
    dialogVisible;
    type;
    deviceId;
    addDeviceSuccess;
    changeType;
    tableLoading = false;
    devicesList = [];
    tableWidth = {
        vehicleImage: Scale * 100,
        failedAt: Scale * 136,
        reason: Scale * 300,
    };
    /** 是否开启隐私模式 */
    get privacyMode() {
        return localStorage.getItem('privacyMode') === 'true';
    }
    // dialog 标题
    get returnTitle() {
        return `${this.$t('failure')}（${this.devicesList.length}）`;
    }
    getList(parentRow) {
        this.tableLoading = true;
        try {
            errList({ libId: parentRow.libId, deviceId: parentRow.deviceId })
                .then((res) => {
                this.devicesList = res.list;
            })
                .finally(() => {
                this.tableLoading = false;
            });
        }
        catch (error) {
            console.log('getList err', error);
        }
        // this.devicesList = [
        //   {
        //     vehicleImage: require('@blade/common/assets/images/user.png'),
        //     failedAt: '2022-9-29 14:45:58',
        //     reason: 'reasonreasonreasonreasonreasonreasonreasonreasonreasonreason',
        //   },
        // ];
    }
    handleClose() {
        this.$emit('update:dialogVisible', false);
    }
    /** 图片增加样式 */
    blurPictureStyle(mattingImage) {
        return `width:${(Scale * mattingImage.width).toFixed(0)}px;`;
    }
};
__decorate([
    Prop()
], default_1.prototype, "dialogVisible", void 0);
__decorate([
    Prop()
], default_1.prototype, "type", void 0);
__decorate([
    Prop()
], default_1.prototype, "deviceId", void 0);
__decorate([
    Prop()
], default_1.prototype, "addDeviceSuccess", void 0);
__decorate([
    Prop()
], default_1.prototype, "changeType", void 0);
default_1 = __decorate([
    Component({
        name: 'model',
        components: { BlurPicture, CombinedPicture },
        i18n: {
            messages: {
                en: {
                    failure: 'Details of Delivery Failure',
                    vehicleImage: 'Vehicle',
                    failedAt: 'Failed At',
                    reason: 'Reason',
                },
                zh: {
                    failure: '下发失败详情',
                    vehicleImage: '车辆',
                    failedAt: '失败时间',
                    reason: '原因',
                },
            },
        },
    })
], default_1);
export default default_1;
